export default {
  title: 'Oops. Page not found!',
  subtitle: 'You have reached the edge of the observable Sportya universe.',
  goHome: 'Go to Homepage',
  contact: 'Let us know how you got here, so that we can build a better world (and website) - <1>contact@sportya.net</1>. \nThank you, friend!',
};
